import script from "./CheckoutRegistration.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutRegistration.vue?vue&type=script&setup=true&lang=js"

import "./CheckoutRegistration.vue?vue&type=style&index=0&id=7f4bb766&lang=css"

const __exports__ = script;

export default __exports__